import { render, staticRenderFns } from "./AgencyContestNameView.vue?vue&type=template&id=3a0c2c79&scoped=true&"
import script from "./AgencyContestNameView.vue?vue&type=script&lang=js&"
export * from "./AgencyContestNameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c2c79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
